import { selectorFamily } from 'recoil';
import axios from '../../common/axiosInterceptor';
import moment from 'moment';
import { startingDate } from '../atoms/startingDate';
import { endingDate } from '../atoms/endingDate';
// import { contactSearch } from '../atoms/contactSearch';
import { user } from '../atoms/user';
import getContactsEvent from '../events/getContacts';

const columns = [
  // {
  //   data: 0,
  //   name: 'crmname',
  //   searchable: true,
  //   orderable: true,
  //   search: {
  //     value: '',
  //     regex: false,
  //   },
  // },
  // {
  //   data: 1,
  //   name: 'name',
  //   searchable: true,
  //   orderable: true,
  //   search: {
  //     value: '',
  //     regex: false,
  //   },
  // },
  // {
  //   data: 2,
  //   name: 'externalid',
  //   searchable: true,
  //   orderable: true,
  //   search: {
  //     value: '',
  //     regex: false,
  //   },
  // },
  // {
  //   data: 3,
  //   name: 'id',
  //   searchable: true,
  //   orderable: true,
  //   search: {
  //     value: '',
  //     regex: false,
  //   },
  // },
  // {
  //   data: 4,
  //   name: 'company',
  //   searchable: true,
  //   orderable: true,
  //   search: {
  //     value: '',
  //     regex: false,
  //   },
  // },
  // {
  //   data: 5,
  //   name: 'deallink',
  //   searchable: true,
  //   orderable: true,
  //   search: {
  //     value: '',
  //     regex: false,
  //   },
  // },
  {
    data: 0,
    name: 'created_at',
    searchable: true,
    orderable: true,
    search: {
      value: '',
      regex: false,
    },
  },
];

export const getContacts = selectorFamily({
  key: 'getContacts',
  get: ({ page, pageSize, search = '', sortModel }) => async ({ get }) => {
    // translate sortModel to order
    const order = sortModel?.field
      ? columns
          .filter((col) => col.name === sortModel.field)
          .map((col) => ({
            column: col.data,
            dir: sortModel.sort,
          }))
      : undefined;

    try {
      let start = get(startingDate);
      let end = get(endingDate);
      // const search = get(contactSearch);
      const storageUser = get(user);
      if (start._i && end._i) {
        start = moment(start._i).format('YYYY-MM-DD');
        end = moment(end._i).format('YYYY-MM-DD');
      }
      const event = {
        ...getContactsEvent,
        businessid: storageUser.businessid,
        apiKey: storageUser.apikey,
        // search.value: 'pip',
        search: { value: search, regex: false },
        start: (page - 1) * pageSize,
        length: pageSize,
        startdate: start,
        enddate: end,
        order: order,
        crmid: storageUser.hasCRM ? storageUser.crmid : getContactsEvent.crmid,
      };
      const result = await axios.post(
        `${process.env.VITE_APP_API_DOMAIN}/${process.env.VITE_APP_API_STAGE}/contacts/getcontacts`,
        event
      );
      return result;
    } catch (error) {
      throw error;
    }
  },
});
